define('LNRS/Components/Social/SiteSocialSharing',["jquery", "eventManager"], function ($, eventManager) {
    function SiteSocialSharing(args) {

        if (!args.isEditing) {
            var pageId = $('body').attr('data-page-id');
            var language = $('body').attr('data-page-language-name');

            $.ajax({
                url: "/GetContextSiteSocialSharingData",
                type: "GET",
                //LNRSSUP-404 Removing X-Requested-With header
                xhr: function () {
                    var xhr = jQuery.ajaxSettings.xhr();
                    var setRequestHeader = xhr.setRequestHeader;
                    xhr.setRequestHeader = function (name, value) {
                        if (name == 'X-Requested-With') return;
                        setRequestHeader.call(this, name, value);
                    }
                    return xhr;
                },
                data: {
                    pageId: pageId,
                    languageName: language,
                    isGlobalSite: (window.location.href.toLowerCase().indexOf("global") >= 0)
                },
                traditional: true,
                dataType: "json"
            })
            .done(function (response) {
                eventManager.trigger("SiteSharingDataLoaded", response);
            }.bind(this))
            .fail(function () {
            }.bind(this))
            .always(function () {
            }.bind(this));
        }
    }

    return function init(args) {
        return new SiteSocialSharing(args);
    };
});
